<button [id]="'nc-button-raised-' + id" *ngIf="isRaised" mat-raised-button
        type="button"
        (click)="onClick && onClick()"
        [color]="color"
        [disabled]="disabled">
  <mat-icon *ngIf="icon">{{icon}}</mat-icon>
  <span>{{label | translate}}</span>
</button>
<button [id]="'nc-button-not-raised-' + id" *ngIf="!isRaised" mat-stroked-button
        type="button"
        [color]="color"
        (click)="onClick && onClick()"
        [disabled]="disabled">
  <mat-icon *ngIf="icon">{{icon}}</mat-icon>
  <span>{{label | translate}}</span>
</button>

